import { Product } from '@/typings/base'

export interface ReducerState {
  item?: Product
  loading: boolean
  error?: any
}
export const initialProductsState: ReducerState = { loading: false }

const productReducer = (state = initialProductsState, action): ReducerState => {
  switch (action.type) {
    case 'GET_SINGLE_PRODUCT_REQUEST':
      // Clear the previously fetched product so a stale item is never shown
      // while the new one is loading.
      return { ...state, loading: true, item: undefined, error: undefined }
    case 'GET_SINGLE_PRODUCT_SUCCESS':
      return { ...state, loading: false, item: action.product }
    case 'GET_SINGLE_PRODUCT_FAILURE':
      return { ...state, loading: false, error: action.error }
    case 'RESET_SINGLE_PRODUCT':
      return { ...initialProductsState }
    default:
      return state
  }
}

export default productReducer
